import script from "./OfflineScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./OfflineScreen.vue?vue&type=script&setup=true&lang=js"

import "./OfflineScreen.vue?vue&type=style&index=0&id=47453988&lang=css"

const __exports__ = script;

export default __exports__